module.exports = __webpack_public_path__ + "img/chufangbanner3.e24f43b1.png";